/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const star_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.722 1.244 3.33 6.599 6.411.635a.801.801 0 0 1 .498 1.368l-5.276 5.23 1.956 7.105a.808.808 0 0 1-1.145.93l-6.5-3.218-6.49 3.215a.81.81 0 0 1-1.145-.93l1.956-7.107-5.28-5.23a.801.801 0 0 1 .498-1.367l6.41-.635 3.326-6.595a.815.815 0 0 1 1.451 0v0Z"
    />
  </svg>
)
export default star_medium
